import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { services } from '../data/services';
import { Icon } from '../utils/icons';
import { SectionHeading } from './SectionHeading';
export function Services() {
  return <section id="services" className="w-full bg-white" data-id="element-113" data-mp="18vhdag16mwim">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-114" data-mp="18x24bvoafxbq">
        <SectionHeading eyebrow="What We Offer" title="Our Core Services" description="We offer a comprehensive range of cleaning and property support services tailored to your needs." data-id="element-115" data-mp="13wmtpbve53xg" />

        <div className="mt-14 grid gap-px bg-gray-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-116" data-mp="u6bcwoqlz095">
          {services.map((service, index) => <motion.article key={service.slug} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.05,
          ease: 'easeOut'
        }} className="group flex flex-col bg-white p-8 transition-colors hover:bg-navy" data-id="element-117" data-mp="l53t1boua1yl" data-mpi={index}>
              <Icon name={service.icon} className="h-8 w-8 text-gold" data-id="element-118" data-mp="2xc1ip4n7wmxg" />
              <h3 className="mt-6 font-display text-lg font-extrabold uppercase tracking-wide text-navy transition-colors group-hover:text-white" data-id="element-119" data-mp="2x9yi5qofvbeh">
                {service.title}
              </h3>
              <p className="mt-3 flex-1 text-[15px] leading-relaxed text-gray-600 transition-colors group-hover:text-white/75" data-id="element-120" data-mp="3pyckujqh2vwd">
                {service.description}
              </p>
              <Link to={`/services/${service.slug}`} className="mt-6 inline-flex items-center gap-2 font-display text-[12px] font-bold uppercase tracking-widest text-navy transition-colors group-hover:text-gold-light" data-id="element-121" data-mp="3g214ninrhlwn">
                Learn More
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-122" data-mp="29nry261qq57w" />
                <span className="sr-only" data-id="element-123" data-mp="1pj16xxlsdqrk">about {service.title}</span>
              </Link>
            </motion.article>)}
        </div>

        <div className="mt-12 text-center" data-id="element-124" data-mp="1lklmo1h3awhu">
          <Link to="/services" className="inline-flex items-center gap-2 border border-navy px-8 py-4 font-display text-[13px] font-bold uppercase tracking-widest text-navy transition-colors hover:bg-navy hover:text-white" data-id="element-125" data-mp="1gqz8u5z6wmkg">
            View All Services
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="11u05wvfa9hwb" />
          </Link>
        </div>
      </div>
    </section>;
}